<app-nav></app-nav>
<div class="container">
  <div class="dailyHospitalCashBanner">
    <img src="../../assets/images/individualLandingPage.png"/>
  </div>
  <div style="margin-left: 12%;">
    <p class="dailyHospitalCashLabel">Are You Married ?</p>
    <input class="dailyHospitalCashInput" name="inputVal" value="yes" (change)="handleDailyInput($event)"  type="radio"/>Yes
    <input class="dailyHospitalCashInput" name="inputVal" value="no" (change)="handleDailyInput($event)" type="radio"/>No

    <div *ngIf="this.inputVal==='yes'">
    <p class="dailyHospitalCashLabel2">Please select no. of children's you have ?</p>
      <input class="dailyHospitalCashInputChild" placeholder="Enter No of childrens" (keydown)="handleKeyDown($event)" name="inputValChild" (change)="handleDailyInputChild($event)" type="number"/>
    </div>
  </div>
  <div class="text-center" style="margin-top: 3%;">
    <p class="text-center text-danger">{{this.error}}</p>
    <button class="dailyHospitalCashBtn" (click)="createProspectForDCA()" type="button">Next</button>
  </div>

  <div class="dailyHospitalCashLogos mt-5">
    <img  class="mr-3" src="../../assets//images/hospital_logos/care.png"/>
    <!-- <img src="../../assets//images/hospital_logos/reliance.png"/> -->
  </div>
</div>
